import React from 'react';
import { HeroBanner } from '../components/HeroBanner';
import { SocialProofBar } from '../components/home/SocialProofBar';
import { TodayInSky } from '../components/home/TodayInSky';
import { HowItWorks } from '../components/home/HowItWorks';
import { PopularServices } from '../components/home/PopularServices';
import { WhyAstroGuide } from '../components/home/WhyAstroGuide';
import { PricingSection } from '../components/home/PricingSection';
import { ReportPreviewSection } from '../components/home/ReportPreviewSection';
import { TopAstrologersSection } from '../components/home/TopAstrologersSection';
import { AstroCalendarSection } from '../components/home/AstroCalendarSection';
import { BlogSection } from '../components/home/BlogSection';
import { ReviewsSection } from '../components/home/ReviewsSection';
import { ForAstrologersSection } from '../components/home/ForAstrologersSection';
import { FaqSection } from '../components/home/FaqSection';
import { FinalCtaSection } from '../components/home/FinalCtaSection';
import { SectionErrorBoundary } from '../components/SectionErrorBoundary';
interface HomePageProps {
  onNavigate: (page: string) => void;
}
export function HomePage({
  onNavigate
}: HomePageProps) {
  return <div className="w-full" data-id="element-24061">
      {/* 1. HERO */}
      <SectionErrorBoundary sectionName="HeroBanner" fallbackMinHeight="min-h-screen" data-id="element-24062">
        <HeroBanner onNavigate={onNavigate} data-id="element-24063" />
      </SectionErrorBoundary>

      {/* 2. SOCIAL PROOF BAR */}
      <SectionErrorBoundary sectionName="SocialProofBar" fallbackMinHeight="min-h-[80px]" data-id="element-24064">
        <SocialProofBar data-id="element-24065" />
      </SectionErrorBoundary>

      {/* 3. СЕГОДНЯ В НЕБЕ */}
      <SectionErrorBoundary sectionName="TodayInSky" data-id="element-24066">
        <TodayInSky onNavigate={onNavigate} data-id="element-24067" />
      </SectionErrorBoundary>

      {/* 4. КАК ЭТО РАБОТАЕТ */}
      <SectionErrorBoundary sectionName="HowItWorks" data-id="element-24068">
        <HowItWorks data-id="element-24069" />
      </SectionErrorBoundary>

      {/* 5. ПОПУЛЯРНЫЕ УСЛУГИ */}
      <SectionErrorBoundary sectionName="PopularServices" data-id="element-24070">
        <PopularServices onNavigate={onNavigate} data-id="element-24071" />
      </SectionErrorBoundary>

      {/* 6. ПОЧЕМУ ASTRIQO */}
      <SectionErrorBoundary sectionName="WhyAstroGuide" data-id="element-24072">
        <WhyAstroGuide data-id="element-24073" />
      </SectionErrorBoundary>

      {/* 7. ТАРИФЫ */}
      <SectionErrorBoundary sectionName="PricingSection" data-id="element-24074">
        <PricingSection onNavigate={onNavigate} data-id="element-24075" />
      </SectionErrorBoundary>

      {/* 8. ПРЕВЬЮ ОТЧЁТА */}
      <SectionErrorBoundary sectionName="ReportPreviewSection" data-id="element-24076">
        <ReportPreviewSection onNavigate={onNavigate} data-id="element-24077" />
      </SectionErrorBoundary>

      {/* 9. ТОП АСТРОЛОГИ */}
      <SectionErrorBoundary sectionName="TopAstrologersSection" data-id="element-24078">
        <TopAstrologersSection onNavigate={onNavigate} data-id="element-24079" />
      </SectionErrorBoundary>

      {/* 10. КАЛЕНДАРЬ */}
      <SectionErrorBoundary sectionName="AstroCalendarSection" data-id="element-24080">
        <AstroCalendarSection onNavigate={onNavigate} data-id="element-24081" />
      </SectionErrorBoundary>

      {/* 11. БЛОГ */}
      <SectionErrorBoundary sectionName="BlogSection" data-id="element-24082">
        <BlogSection onNavigate={onNavigate} data-id="element-24083" />
      </SectionErrorBoundary>

      {/* 12. ОТЗЫВЫ */}
      <SectionErrorBoundary sectionName="ReviewsSection" data-id="element-24084">
        <ReviewsSection data-id="element-24085" />
      </SectionErrorBoundary>

      {/* 13. ДЛЯ АСТРОЛОГОВ */}
      <SectionErrorBoundary sectionName="ForAstrologersSection" data-id="element-24086">
        <ForAstrologersSection onNavigate={onNavigate} data-id="element-24087" />
      </SectionErrorBoundary>

      {/* 14. FAQ */}
      <SectionErrorBoundary sectionName="FaqSection" data-id="element-24088">
        <FaqSection data-id="element-24089" />
      </SectionErrorBoundary>

      {/* 15. ФИНАЛЬНЫЙ CTA */}
      <SectionErrorBoundary sectionName="FinalCtaSection" data-id="element-24090">
        <FinalCtaSection data-id="element-24091" />
      </SectionErrorBoundary>
    </div>;
}